import React, { FC } from 'react';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import { useWeb3React } from '@web3-react/core';

export const AuthorizationRoute: FC<RouteProps> = ({ children, ...props }) => {
  const location = useLocation<{ from: string }>();
  const { account } = useWeb3React();

  if (account) {
    return (
      <Redirect
        to={{
          pathname: location.state?.from || '/your-nfts',
        }}
      />
    );
  }

  return <Route {...props}>{children}</Route>;
};
